import { render, staticRenderFns } from "./CampaignSelectLight.vue?vue&type=template&id=0376facc"
import script from "./CampaignSelectLight.vue?vue&type=script&lang=js"
export * from "./CampaignSelectLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports